const NOT_PLAIN_TEXT = /[<>\p{Cc}]|&(?:[a-z]+|#x?[0-9a-f]+);/iu;

const CONTROL_CHARS = /\p{Cc}/u;

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const checkedText = (
  value: unknown,
  name: string,
  max: number,
  forbidden: RegExp
): string => {
  if (typeof value !== 'string') throw new Error(`${name} is not a string`);
  const text = value.trim();
  if (!text || text.length > max || forbidden.test(text)) {
    throw new Error(`${name} is empty, too long or has disallowed characters`);
  }
  return text;
};

/** For strings that may be rendered as HTML (chart labels). */
export const plainText = (value: unknown, name: string, max: number): string =>
  checkedText(value, name, max, NOT_PLAIN_TEXT);

/** For strings that are only ever rendered as escaped text (table content). */
export const escapedText = (
  value: unknown,
  name: string,
  max: number
): string => checkedText(value, name, max, CONTROL_CHARS);

export const list = (
  value: unknown,
  name: string,
  min: number,
  max: number
): unknown[] => {
  if (!Array.isArray(value) || value.length < min || value.length > max) {
    throw new Error(`${name} must be a list of ${min} to ${max}`);
  }
  return value;
};
